import React from "react";
import SpecialistAssignmentBoard from "./SpecialistAssignmentBoard";
import FlowEngineGlobalGate from "../specialist-flow-engine/FlowEngineGlobalGate";

const SpecialistCoordinatorSelectionScreen = () => {
  return (
    <FlowEngineGlobalGate>
      <SpecialistAssignmentBoard
        roleKey="coordinator"
        titleKey="specialist.selection.coordinator.title"
        defaultTitle="Bandeja del Coordinador"
      />
    </FlowEngineGlobalGate>
  );
};

export default SpecialistCoordinatorSelectionScreen;
